import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getMonthStartAndEndDates } from "../../../../../app/utility/monthStartEndDate";
import { DataTable } from "../../../../../components/data-table";
import { ONDCOrdersDataGridCols } from "./data-grid-cols";
import { OndcService } from "../../../../../app/core/ondc.service";
import { set } from "react-datepicker/dist/date_utils";
import moment from "moment";

export const TotalOrdersList = () => {
    const { startDate, endDate } = getMonthStartAndEndDates();
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(false);
    const [inputValue, setInputValue] = useState("");
    const [fromDate, setFromDate] = useState<any>(startDate);
    const [toDate, setToDate] = useState<any>(endDate);
    const [ordersData, setOrdersData] = useState<any>([]);
    const initialPayload = {
        DateFrom: startDate,
        DateTo: endDate,
        limit: 10,
        page: 0,
    };
    const [pageCount, setPageCount] = useState<any>(initialPayload);

    useEffect(() => {
        totalOrdersData(initialPayload);
    }, []);

    const totalOrdersData = async (payload: any) => {
        setLoading(true);
        try {
            const res = await OndcService.getOndcOrders(payload);
            res.results.forEach((element: any) => {
                element.created_dt = moment(element?.created_dt).format("DD-MM-YYYY");
                element.bap_app = element?.select?.context?.bap_id;
                element.amount = (element?.on_confirm) ? `₹ ${element?.on_confirm?.message?.order?.quote?.price?.value}` : "";
                element.details = <button className="primary-bg text-white rounded px-4 py-1 border-0" onClick={() => handleViewOrder(element._id)}>View</button>
            });
            setOrdersData(res);
            setLoading(false);
            setPageCount(payload);
        }
        catch (error) {
            setLoading(false);
        }
    }

    const handleViewOrder = (id: any) => {
        navigate(`/dashboard/ondc-orders/${id}/view`)
     }

    const handleChange = (e: any) => {
        let payload = { limit: 10, page: 0, search: e.target.value, DateFrom: fromDate, DateTo: toDate };
        setInputValue(e.target.value);
        totalOrdersData(payload);
    }

    const selectFromDate = (e: any) => {
        setFromDate(e.target.value);
    }

    const selectToDate = (e: any) => {
        setToDate(e.target.value)
    }

    const onSearchData = () => {
        if (inputValue || fromDate || toDate) {
            let payload: any = {
                search: inputValue ? inputValue : null,
                DateFrom: fromDate ? fromDate : null,
                DateTo: toDate ? toDate : null,
                limit: 10,
                page: 0
            };
            totalOrdersData(payload);
            setPageCount(payload);
        } else {
        }
    };

    const onClear = () => {
        setInputValue("");
        setPageCount(initialPayload);
        setFromDate(startDate);
        setToDate(endDate);
        totalOrdersData(initialPayload);
    };


    const onPageChange = (data: any) => {
        let payload = { limit: 10, page: data, DateFrom: fromDate, DateTo: toDate };
        setPageCount(payload);
        totalOrdersData(payload);
    };

    const onSelectPage = (data: any) => {
        let payload = { limit: 10, page: data, DateFrom: fromDate, DateTo: toDate };
        setPageCount(payload);
        totalOrdersData(payload);
    };

    return (
        <div className="container-fluid content-bg-color">
            <h4 className="primary-color fw-bold mt-3">ONDC Orders</h4>
            <div className="row mx-1">
                <input type="text" className="form-control  mt-2" value={inputValue} onChange={handleChange} placeholder="Search ..." />
                <div className="row mt-2">
                    <div className="col-md-5 mb-2 ps-0">
                        <input type="date" className="form-control" value={fromDate} onChange={selectFromDate} />
                    </div>
                    <div className="col-md-5 mb-2">
                        <input type="date" className="form-control" value={toDate} min={fromDate} onChange={selectToDate} />
                    </div>
                    <div className="col-md-1 mb-2"><button className="form-control primary-bg text-white w-100" onClick={onSearchData}>Search</button></div>
                    <div className="col-md-1 mb-2"><button className="form-control primary-bg text-white w-100" onClick={onClear}>Clear</button></div>
                </div>
            </div>
            <div className="col-12 px-0 my-2">
                {loading ? (
                    <div className="text-center p-5">
                        <div className="spinner-border" role="status">
                            <span className="sr-only"></span>
                        </div>
                    </div>
                ) : (
                    <DataTable
                        tableData={ordersData}
                        TableCols={ONDCOrdersDataGridCols}
                        onActions={(e: any) => { }}
                        onPageChange={(e: any) => onPageChange(e)}
                        onSelectPageChange={(e: any) => onSelectPage(e)}
                        pageCount={pageCount}
                        pagination={true}
                    />
                )}
            </div>
        </div>
    )
}